import '@babel/polyfill';
import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';
import './plugins/axios';
import App from './App.vue';
import router from './router';
import store from './store';
import VueLodash from 'vue-lodash'
import MdComponents from 'md-components';
import { createI18n } from './i18n';

Vue.use(BootstrapVue);
Vue.use(VueLodash);
Vue.use(MdComponents);

Vue.config.productionTip = false;
/*
 * If using Jquery plugins they will expect to be available in the global namespace,
 * which isn’t the case when you import/require it. So manually assign jquery to
 * window. Use require instead of import because the imports are hoisted to the
 * top of a file by the compiler, which would break VueJS code.
 */
const $ = require('jquery');
window.jQuery = window.$ = $;

import VueProgressBar from 'vue-progressbar';

const options = {
    color: '#6d8d23',
    failedColor: '#874b4b',
    thickness: '2px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 300,
    },
    autoRevert: true,
    autoFinish: true,
    location: 'top',
    inverse: false,
};

Vue.use(VueProgressBar, options);

// use moment's german locale
const moment = require('moment');
require('moment/locale/de');

Vue.use(require('vue-moment'), {
    moment,
});


let listenerId = 0;
let listenerMap = {};
let meKey = 'mdmel';
let mmKey = 'mdmml';
let drKey = 'mddnrl';
let mlKey = 'mdmll';

Vue.directive('tooltip', {
    bind: function (el, binding, vnode) {
        let id = listenerId++;
        el.dataset.mdttid = id;
        listenerMap[meKey + id] = function () {
            if (!binding.value) return;
            if (typeof binding.value === 'string') {
                window.app.ToggleTooltip(el, {
                    toggled: true,
                    header: binding.value,
                });
            } else if (Object.prototype.toString.call(binding.value) == '[object Function]') { //for generated string you have to wrap them in functions example: GetAmountWrapper() { return  () => { return view.GetAmount(date) }}
                if (binding.value()) {
                    if (typeof binding.value() === 'string') {
                        window.app.ToggleTooltip(el, {
                            toggled: true,
                            header: binding.value(),
                        });
                    } else {
                        window.app.ToggleTooltip(el, binding.value());
                    }

                }

            } else {
                window.app.ToggleTooltip(el, binding.value);
            }
        };
        el.addEventListener('mouseenter', listenerMap[meKey + id]);

        listenerMap[mmKey + id] = function () {
            window.app.RepositionTooltip();
        };
        el.addEventListener('mousemove', listenerMap[mmKey + id]);

        listenerMap[mlKey + id] = function () {
            window.app.ToggleTooltip(null, {
                toggled: false,
                header: '',
                type: '',
                componentState: null,
            });
        };
        el.addEventListener('mouseleave', listenerMap[mlKey + id]);
    },
    inserted: function (el, binding, vnode) {
        const id = el.dataset.mdttid;

        const mutationObserver = new MutationObserver(function (mutations) {
            // console.log('removing element');
            // console.log(el);
            mutations.forEach((mutation) => {
                if (!mutation.removedNodes) return;

                const hasElement = !![ ...mutation.removedNodes ].find(e => e === el);
                if (hasElement) {
                    window.app.ToggleTooltip(null, {
                        toggled: false,
                        header: '',
                        type: '',
                        componentState: null,
                    });
                    // console.log('element removed');
                }
            });
        });
        mutationObserver.observe(el.parentElement, { childList: true });
        listenerMap[drKey + id] = mutationObserver;
    },
    unbind(el, binding) {
        if (!el.dataset) {
            return;
        }

        let id = el.dataset.mdttid;

        el.removeEventListener('mouseenter', listenerMap[meKey + id]);
        el.removeEventListener('mousemove', listenerMap[mmKey + id]);
        el.removeEventListener('mouseleave', listenerMap[mlKey + id]);
        if (listenerMap[drKey + id]) listenerMap[drKey + id].disconnect();
        delete listenerMap[meKey + id];
        delete listenerMap[mmKey + id];
        delete listenerMap[mlKey + id];
        delete listenerMap[drKey + id];
        delete el.dataset.mdttid;

    },
})

Vue.directive('texttooltip', {
    bind: function (el, binding, vnode) {
        if(binding.value == null || binding.value == undefined || binding.value == '') {
            return;
        } else {
            el.setAttribute('data-texttooltip', binding.value);
            el.classList.add('with-texttooltip');

            //const position = binding.value.position;
            el.classList.add(`texttooltip--top`);
        }
        
    },
    inserted: function (el, binding, vnode) {
        
    },
    unbind(el, binding) {
       

    },
})

import helpers from './helpers';
import rosterhelper from './rosterhelper';

Vue.use(helpers, store);
Vue.use(rosterhelper, store);


const bar = () => import('./components/uicomponents/bar.vue');
const label = () => import('./components/uicomponents/label.vue');
const inputc = () => import('./components/uicomponents/generic/input.vue');
const button = () => import('./components/uicomponents/button.vue');
const checkbox = () => import('./components/uicomponents/generic/checkbox.vue');
const colorpickicon = () => import('./components/uicomponents/generic/colorpickicon.vue');
const slider = () => import('./components/uicomponents/slider.vue');
const sidebar = () => import('./components/uicomponents/sidebar.vue');
const emotlist = () => import('./components/uicomponents/emotlist.vue');
const menutabs = () => import('./components/uicomponents/menutabs.vue');
const datetime = () => import('./components/uicomponents/generic/datetime.vue');
const datatable = () => import('./components/uicomponents/datatable.vue');
const datatablesimple = () => import('./components/uicomponents/datatablesimple.vue');
const datepicker = () => import('./components/uicomponents/datepicker/datepicker.vue');
const headerdate = () => import('./components/uicomponents/headerdate.vue');
const tickertext = () => import('./components/uicomponents/tickertext.vue');
const rosterday = () => import('./components/uicomponents/rosterday.vue');
const timemarks = () => import('./components/uicomponents/timemarks.vue');
const listlabel = () => import('./components/uicomponents/listlabel.vue');
const menudetails = () => import('./components/menucontext/menudetails.vue');
const headeroptions = () => import('./components/testroster/HeaderOptions.vue');
const chartcontainer = () => import('./components/uicomponents/chartcontainer.vue');
const chartcomponent = () => import('./components/uicomponents/chartcomponent.vue');
const headerbuttonstack = () => import('./components/uicomponents/headerbuttonstack.vue');
const dropdowncontainer = () => import('./components/uicomponents/dropdowncontainer.vue');
const headerdisplayoptions = () => import('./components/testroster/HeaderDisplayOptions.vue');
const burgermenu = () => import('./components/uicomponents/burgermenu.vue');
const employeedisplayoptions = () => import('./components/employeecontext/employeedata/EmployeeDisplayOptions.vue');
const employeeentry = () => import('./components/uicomponents/employeeentry.vue');
const colorselection = () => import('./components/uicomponents/colorselection.vue');
const employeepicture = () => import('./components/uicomponents/employeepicture.vue');
const datatablefilter = () => import('./components/uicomponents/datatablefilter.vue');
const datatablepaging = () => import('./components/uicomponents/datatablepaging.vue');
const datatabletextfilter = () => import('./components/uicomponents/datatabletextfilter.vue');
const employeetypeform = () => import('./components/plancontext/EmployeeTypeForm.vue');
const employeerulesform = () => import('./components/plancontext/EmployeeRulesForm.vue');
const employeedetailinfo = () => import('./components/employeecontext/employeedetail/EmployeeDetailInfo.vue');
const employeedetailtype = () => import('./components/employeecontext/employeedetail/EmployeeDetailType.vue');
const employeedetailrules = () => import('./components/employeecontext/employeedetail/EmployeeDetailRules.vue');
const employeedetailskills = () => import('./components/employeecontext/employeedetail/EmployeeDetailSkills.vue');
const employeedetailpreferences = () => import('./components/employeecontext/employeedetail/EmployeeDetailPreferences.vue');
const employeedetailactualshifts = () => import('./components/employeecontext/employeedetail/EmployeeDetailActualShifts.vue');
const employeedetailavailabilities = () => import('./components/employeecontext/employeedetail/EmployeeDetailAvailabilities.vue');
const vacationmonthpopup = () => import('./components/preferencecontext/VacationMonthPopup.vue');
const aboutpopup = () => import('./components/aboutpopup.vue');
const monthlyholidayentry = () => import('./components/uicomponents/monthlyholidayentry.vue');
const dateselectionheader = () => import('./components/uicomponents/dateselectionheader.vue');
const planningemployeeoverview = () => import('./components/planningindicatorcontext/PlanningEmployeeOverview.vue');
const crewlaborplanninghelper = () => import('./components/planningindicatorcontext/CrewLaborPlanningHelper.vue');
const rosterbackupoverview = () => import('./components/rostercontext/RosterBackupOverview.vue');
const rosternoticeoverview = () => import('./components/rostercontext/RosterNoticeOverview.vue');
const monthlyclosingsummary = () => import('./components/workbalancecontext/monthlyClosingSummary.vue');
const skillsDetails = () => import('./components/employeecontext/skills/skillsDetails');
const projectdetailplannedshifts = () => import('./components/shiftcontext/projectdetail/ProjectDetailPlannedShifts.vue');
const projectdetailactualshifts = () => import('./components/shiftcontext/projectdetail/ProjectDetailActualShifts.vue');
const employeeextrapaymentoverview = () => import('./components/workbalancecontext/EmployeeExtraPaymentOverview.vue');
const employeeaverageworktimeoverview = () => import('./components/workbalancecontext/EmployeeAverageWorktimeOverview.vue');
const autologout = () => import('./components/AutoLogout.vue');
const vlhThresholdCurveRow = () => import('./components/planningindicatorcontext/VlhThresholdCurveRow.vue');

Vue.component('bar', bar);
Vue.component('labelc', label);
Vue.component('inputc', inputc);
Vue.component('buttonc', button);
Vue.component('checkbox', checkbox);
Vue.component('colorpickicon', colorpickicon);
Vue.component('slider', slider);
Vue.component('sidebar', sidebar);
Vue.component('emotlist', emotlist);
Vue.component('menutabs', menutabs);
Vue.component('datetime', datetime);
Vue.component('datatable', datatable);
Vue.component('datatablesimple', datatablesimple);
Vue.component('datepicker', datepicker);
Vue.component('headerdate', headerdate);
Vue.component('tickertext', tickertext);
Vue.component('rosterday', rosterday);
Vue.component('timemarks', timemarks);
Vue.component('listlabel', listlabel);
Vue.component('menudetails', menudetails);
Vue.component('headeroptions', headeroptions);
Vue.component('chartcontainer', chartcontainer);
Vue.component('chartcomponent', chartcomponent);
Vue.component('headerbuttonstack', headerbuttonstack);
Vue.component('dropdowncontainer', dropdowncontainer);
Vue.component('headerdisplayoptions', headerdisplayoptions);
Vue.component('burgermenu', burgermenu);
Vue.component('employeedisplayoptions', employeedisplayoptions);
Vue.component('employeeentry', employeeentry);
Vue.component('colorselection', colorselection);
Vue.component('employeepicture', employeepicture);
Vue.component('datatablepaging', datatablepaging);
Vue.component('datatablefilter', datatablefilter);
Vue.component('datatabletextfilter', datatabletextfilter);
Vue.component('employeetypeform', employeetypeform);
Vue.component('employeerulesform', employeerulesform);
Vue.component('employeedetailinfo', employeedetailinfo);
Vue.component('employeedetailtype', employeedetailtype);
Vue.component('employeedetailrules', employeedetailrules);
Vue.component('employeedetailskills', employeedetailskills);
Vue.component('employeedetailpreferences', employeedetailpreferences);
Vue.component('employeedetailactualshifts', employeedetailactualshifts);
Vue.component('employeedetailavailabilities', employeedetailavailabilities);
Vue.component('vacationmonthpopup', vacationmonthpopup);
Vue.component('aboutpopup', aboutpopup);
Vue.component('monthlyholidayentry', monthlyholidayentry);
Vue.component('dateselectionheader', dateselectionheader);
Vue.component('planningemployeeoverview', planningemployeeoverview);
Vue.component('crewlaborplanninghelper', crewlaborplanninghelper);
Vue.component('rosterbackupoverview', rosterbackupoverview);
Vue.component('rosternoticeoverview', rosternoticeoverview);
Vue.component('monthlyclosingsummary', monthlyclosingsummary);
Vue.component('skillsDetails', skillsDetails);
Vue.component('projectdetailplannedshifts', projectdetailplannedshifts);
Vue.component('projectdetailactualshifts', projectdetailactualshifts);
Vue.component('employeeextrapaymentoverview', employeeextrapaymentoverview);
Vue.component('employeeaverageworktimeoverview', employeeaverageworktimeoverview);
Vue.component('autologout', autologout);
Vue.component('vlhThresholdCurveRow', vlhThresholdCurveRow);

const inputbutton = () => import('./components/uicomponents/datatable/inputbutton.vue');
Vue.component('inputbutton', inputbutton);

const i18n = createI18n();

new Vue({
    i18n,
    store,
    router,
    render: h => h(App),
}).$mount('#app');
